import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { RootState } from "../../store";
import { NotificationDataType, PlatformType } from "@/gql/graphql";

export interface AuthPayload {
  __typename?: "User" | undefined;
  id: number;
  email: string;
  lastName?: string | null | undefined;
  name: string;
  picture: string;
}

export interface PushTokens {
  pushToken: string;
  platform: PlatformType;
}

interface NotificationData {
  type: NotificationDataType;
  data: string;
}

export interface UserState {
  query: string;
  user: AuthPayload | null;
  pushTokens: PushTokens;
  notificationData: NotificationData | null;
  userCountry: {
    id: number;
    name_fr: string;
    name_en: string;
  };
}

const initialState: UserState = {
  query: "",
  user: null,
  pushTokens: {
    pushToken: "",
    platform: PlatformType.Web,
  },
  notificationData: null,
  userCountry: {
    id: 1,
    name_fr: "Cote d'Ivoire",
    name_en: "Ivory Coast",
  },
};

export const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    setQuery: (state, action: PayloadAction<string>) => {
      state.query = action.payload;
    },
    setUser: (state, action: PayloadAction<AuthPayload>) => {
      state.user = action.payload;
    },
    setPushTokens: (state, action: PayloadAction<PushTokens>) => {
      state.pushTokens = action.payload;
    },
    setNotificationData: (
      state,
      action: PayloadAction<NotificationData | null>
    ) => {
      state.notificationData = action.payload;
    },
    setUserCountry: (
      state,
      action: PayloadAction<{
        id: number;
        name_fr: string;
        name_en: string;
      }>
    ) => {
      state.userCountry = action.payload;
    },
  },
});
export const selectUserQuery = (state: RootState) => state.customer.query;
export const selectUser = (state: RootState) => state.customer.user;
export const selectPushTokens = (state: RootState) => state.customer.pushTokens;
export const selectUserCountry = (state: RootState) => {
  if (state.customer.userCountry) {
    return state.customer.userCountry;
  } else {
    return initialState.userCountry;
  }
};

export const selectNotificationData = (state: RootState) =>
  state.customer.notificationData;
export const {
  setQuery,
  setUser,
  setPushTokens,
  setNotificationData,
  setUserCountry,
} = userSlice.actions;
export default userSlice.reducer;
